import {
    type SendCustomMailResponseType,
    type SendCustomMailRequestType
} from "./type";
import {
    request
} from "../request";

const sendCustomMail = async (
    params: SendCustomMailRequestType
): Promise<SendCustomMailResponseType> => {
    return await request<SendCustomMailResponseType>(
        "/notification/sendCustomMail",
        {
            body: JSON.stringify(params),
            method: "POST"
        }
    );
};
export default sendCustomMail;
